import { useState } from 'react';
import { SvgIcon } from '../SvgIcon';
import { useTheme } from '../ThemeContext';

/** CUBA MoonLight — toggles body light-only / dark-only */
export function MoonLight() {
  const { mixLayout, setMixLayout } = useTheme();
  const [moonlight, setMoonlight] = useState(mixLayout === 'dark-only');

  const toggle = () => {
    if (moonlight) {
      setMixLayout('light-only');
      setMoonlight(false);
    } else {
      setMixLayout('dark-only');
      setMoonlight(true);
    }
  };

  return (
    <li>
      <div className={`mode ${moonlight ? 'active' : ''}`} onClick={toggle} role="button" tabIndex={0}>
        <SvgIcon iconId="moon" />
      </div>
    </li>
  );
}
